module.exports = "/_next/static/images/game-2-menu-double-tap-pointer-118cd6f829ba0860a843e2b41cf6c894.png";